document.addEventListener('DOMContentLoaded', function() {
    const scrollableWidget = document.querySelector('.scrollable-widget');
    const widgetContent = document.querySelector('.widget-content');
    const containerWidget = document.querySelector('.container-widget');
    const navPrev = document.getElementById('navPrev');
    const navNext = document.getElementById('navNext');
    
    if (!scrollableWidget || !navPrev || !navNext || !containerWidget) {
        console.error('Important elements not found');
        return;
    }
    
    const scrollAmount = 300; // Scroll distance per click
    
    // Function to update navNext button position (fixed when widget is visible)
    function updateNavNextPosition() {
        if (!navNext || !containerWidget) return;
        
        const containerRect = containerWidget.getBoundingClientRect();
        const viewportHeight = window.innerHeight - 60;
        const viewportWidth = window.innerWidth;
        const containerHeight = containerRect.height;
        
        // Check if widget is visible in viewport
        const isWidgetVisible = (
            containerRect.top < viewportHeight &&
            containerRect.bottom > -30 &&
            containerRect.left < viewportWidth &&
            containerRect.right > 0
        );
        
        const isWidgetBottomVisible = containerRect.bottom < viewportHeight;
        
        if (isWidgetVisible) {
            if(isWidgetBottomVisible) {
                // Reset to absolute positioning when widget bottom is not visible
                navNext.style.position = 'absolute';
                navNext.style.bottom = '';
                navNext.style.right = '';
                navNext.style.zIndex = '';
            } else {
                // When widget bottom is visible, button is fixed at bottom right of viewport
                navNext.style.position = 'fixed';
                navNext.style.bottom = '20px';
                navNext.style.right = '40px';
                navNext.style.zIndex = '1000';
            }
        } else {
            // Reset to absolute positioning when widget bottom is not visible
            navNext.style.position = 'absolute';
            navNext.style.bottom = '';
            navNext.style.right = '';
            navNext.style.zIndex = '';
        }
    }
    
    // Use Intersection Observer to track widget visibility
    const observerOptions = {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0 // trigger when any part is visible
    };
    
    const widgetObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            updateNavNextPosition();
        });
    }, observerOptions);
    
    // Observe the container widget
    widgetObserver.observe(containerWidget);
    
    // Also update on scroll and resize
    let positionUpdateTimeout;
    function schedulePositionUpdate() {
        clearTimeout(positionUpdateTimeout);
        positionUpdateTimeout = setTimeout(updateNavNextPosition, 10);
    }
    
    window.addEventListener('scroll', schedulePositionUpdate);
    window.addEventListener('resize', schedulePositionUpdate);
    
    // Initial position update
    updateNavNextPosition();
    
    // Function to replace img tags with SVG content
    async function replaceMarkerImages() {
        const markerImages = document.querySelectorAll('.widget-item-marker[src]');
        
        for (const img of markerImages) {
            try {
                const response = await fetch(img.src);
                const svgText = await response.text();
                
                // Create SVG element from text
                const parser = new DOMParser();
                const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
                const svgElement = svgDoc.querySelector('svg');
                
                if (svgElement) {
                    // Transfer style and classes
                    const style = img.getAttribute('style');
                    const classes = img.getAttribute('class');
                    
                    // Remove width attribute so CSS controls the width
                    svgElement.removeAttribute('width');
                    svgElement.removeAttribute('height');
                    
                    if (style) svgElement.setAttribute('style', style);
                    if (classes) svgElement.setAttribute('class', classes);
                    
                    // Replace img with svg
                    img.parentNode.replaceChild(svgElement, img);
                }
            } catch (error) {
                console.error('Error loading SVG:', img.src, error);
            }
        }
        
        // Also replace path images with SVG
        const pathImages = document.querySelectorAll('.widget-path[src]');
        
        for (const img of pathImages) {
            try {
                const response = await fetch(img.src);
                const svgText = await response.text();
                
                // Create SVG element from text
                const parser = new DOMParser();
                const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
                const svgElement = svgDoc.querySelector('svg');
                
                if (svgElement) {
                    // Transfer style, data-item and classes
                    const style = img.getAttribute('style');
                    const dataItem = img.getAttribute('data-item');
                    const classes = img.getAttribute('class');
                    
                    // Remove width attribute so CSS controls the width
                    svgElement.removeAttribute('width');
                    svgElement.removeAttribute('height');
                    
                    if (style) svgElement.setAttribute('style', style);
                    if (dataItem) svgElement.setAttribute('data-item', dataItem);
                    if (classes) svgElement.setAttribute('class', classes);
                    
                    // Replace img with svg
                    img.parentNode.replaceChild(svgElement, img);
                }
            } catch (error) {
                console.error('Error loading SVG:', img.src, error);
            }
        }
    }
    
    // Function to detect mobile devices
    function isMobile() {
        return window.matchMedia('(max-width: 768px)').matches;
    }
    
    function updateNavButtons() {
        const widgetItems = document.querySelectorAll('.widget-item');
        const activeItem = document.querySelector('.widget-item.active');
        
        if (!activeItem || widgetItems.length === 0) {
            navPrev.disabled = true;
            navNext.disabled = true;
            return;
        }
        
        const activeItemNumber = parseInt(activeItem.getAttribute('data-item'));
        const isLastItem = activeItemNumber === widgetItems.length;
        
        // Enable/disable arrows based on active item
        navPrev.disabled = activeItemNumber === 1;
        navNext.disabled = false; // Always enable navNext, but change behavior at end
        
        // Update arrow appearance when at the end
        updateArrowForEndState(isLastItem);
    }
    
    // Function to check if last flag is active and update arrow
    function checkScrollEndState() {
        const widgetItems = document.querySelectorAll('.widget-item');
        const activeItem = document.querySelector('.widget-item.active');
        
        if (activeItem && widgetItems.length > 0) {
            const activeItemNumber = parseInt(activeItem.getAttribute('data-item'));
            const isLastItem = activeItemNumber === widgetItems.length;
            
            // Update arrow only if last flag is active
            updateArrowForEndState(isLastItem);
        }
    }
    
    // Function to update arrow appearance for end state
    function updateArrowForEndState(isAtEnd) {
        if (!navNext) return;
        
        if (isAtEnd) {
            // Add class to rotate arrow 180 degrees (back arrow)
            navNext.classList.add('nav-arrow-back');
            navNext.setAttribute('aria-label', 'Back to start');
        } else {
            // Remove class to show forward arrow
            navNext.classList.remove('nav-arrow-back');
            navNext.setAttribute('aria-label', 'Vor');
        }
    }
    
    // Function to activate an item (like on marker click)
    function activateItem(widgetItem, skipScroll) {
        const widgetItems = document.querySelectorAll('.widget-item');
        
        // Deactivate all widget items
        widgetItems.forEach(function(item) {
            item.classList.remove('active');
        });
        
        // Activate current widget item
        widgetItem.classList.add('active');
        
        // Make paths visible up to the active item
        const activeItemNumber = parseInt(widgetItem.getAttribute('data-item'));
        updateVisiblePaths(activeItemNumber);
        
        // Define scroll function
        function performScroll() {
            // Calculate widget item position relative to scrollable container
            const itemRect = widgetItem.getBoundingClientRect();
            const scrollableRect = scrollableWidget.getBoundingClientRect();
            
            // Current scroll position + relative position of item
            const currentScrollLeft = scrollableWidget.scrollLeft;
            const itemLeftRelative = itemRect.left - scrollableRect.left;
            
            // Check if first or last item
            const isFirstItem = activeItemNumber === 1;
            const isLastItem = activeItemNumber === widgetItems.length;
            
            let targetScrollLeft;
            
            if (isMobile()) {
                // Mobile: align left (with some distance from left edge)
                const leftOffset = 50; // Distance from left edge in pixels
                if (isFirstItem) {
                    targetScrollLeft = 0;
                } else if (isLastItem) {
                    const maxScroll = scrollableWidget.scrollWidth - scrollableWidget.clientWidth;
                    targetScrollLeft = maxScroll;
                } else {
                    // Left-aligned with offset
                    targetScrollLeft = currentScrollLeft + itemLeftRelative - leftOffset;
                }
            } else {
                // Desktop: as before
                if (isFirstItem) {
                    // First item: don't center, just scroll to start
                    targetScrollLeft = 0;
                } else if (isLastItem) {
                    // Last item: don't center, scroll to end
                    const maxScroll = scrollableWidget.scrollWidth - scrollableWidget.clientWidth;
                    targetScrollLeft = maxScroll;
                } else {
                    // All other items: center
                    const widgetWidth = scrollableWidget.clientWidth;
                    targetScrollLeft = currentScrollLeft + itemLeftRelative - (widgetWidth / 2) + (itemRect.width / 2);
                }
            }
            
            // Store current vertical scroll position to prevent jumping
            const initialScrollY = window.scrollY;
            let scrollCheckCount = 0;
            const maxScrollChecks = 50; // Maximum number of checks
            
            // Horizontal scroll first
            scrollableWidget.scrollTo({
                left: targetScrollLeft,
                behavior: 'smooth'
            });
            
            // Function to perform vertical scroll after horizontal scroll completes
            function performVerticalScroll() {
                const viewportHeight = window.innerHeight;
                
                // Only scroll vertically if viewport height is greater than 1000px
                if (viewportHeight > 1000) {
                    // Find the title element within the active item
                    const itemTitle = widgetItem.querySelector('.widget-item-title');
                    if (itemTitle) {
                        // Recalculate position after horizontal scroll
                        const titleRect = itemTitle.getBoundingClientRect();
                        
                        // Calculate position to make title visible (not too far down)
                        // Position title in upper portion of viewport (e.g., 30% from top)
                        const targetTitleTop = viewportHeight * 0.3;
                        const titleTop = titleRect.top;
                        const scrollOffsetY = titleTop - targetTitleTop;
                        
                        // Only scroll if we need to move up (prevent downward jumps)
                        if (scrollOffsetY < 0) {
                            // Scroll window vertically to position title
                            window.scrollTo({
                                top: window.scrollY + scrollOffsetY,
                                behavior: 'smooth'
                            });
                        } else {
                            // If we would scroll down, restore original position first
                            window.scrollTo({
                                top: initialScrollY,
                                behavior: 'instant'
                            });
                            // Then scroll to target
                            setTimeout(function() {
                                window.scrollTo({
                                    top: window.scrollY + scrollOffsetY,
                                    behavior: 'smooth'
                                });
                            }, 10);
                        }
                    }
                } else {
                    // For smaller screens: position title at top of viewport
                    const itemTitle = widgetItem.querySelector('.widget-item-title');
                    if (itemTitle) {
                        // Recalculate position after horizontal scroll
                        const titleRect = itemTitle.getBoundingClientRect();
                        
                        // Position title at top of viewport (with small offset for spacing)
                        const targetTitleTop = 150; // Small offset from top
                        const titleTop = titleRect.top;
                        const scrollOffsetY = titleTop - targetTitleTop;
                        
                        // Only scroll if we need to move up (prevent downward jumps)
                        if (scrollOffsetY < 0) {
                            // Scroll window vertically to position title at top
                            window.scrollTo({
                                top: window.scrollY + scrollOffsetY,
                                behavior: 'smooth'
                            });
                        } else {
                            // If we would scroll down, restore original position first
                            window.scrollTo({
                                top: initialScrollY,
                                behavior: 'instant'
                            });
                            // Then scroll to target
                            setTimeout(function() {
                                window.scrollTo({
                                    top: window.scrollY + scrollOffsetY,
                                    behavior: 'smooth'
                                });
                            }, 10);
                        }
                    }
                }
            }
            
            // Check if horizontal scroll has completed by monitoring scroll position
            function checkHorizontalScrollComplete() {
                const currentScrollLeft = scrollableWidget.scrollLeft;
                const scrollDifference = Math.abs(currentScrollLeft - targetScrollLeft);
                
                // If scroll position is close to target (within 5px) or max checks reached
                if (scrollDifference < 5 || scrollCheckCount >= maxScrollChecks) {
                    // Horizontal scroll is complete, now perform vertical scroll
                    performVerticalScroll();
                } else {
                    scrollCheckCount++;
                    // Check again immediately
                    requestAnimationFrame(checkHorizontalScrollComplete);
                }
            }
            
            // Start checking for horizontal scroll completion
            requestAnimationFrame(checkHorizontalScrollComplete);
        }
        
        // Skip scroll if requested (e.g., on initial load)
        if (!skipScroll) {
            // On mobile devices: 400ms delay after activation
            if (isMobile()) {
                setTimeout(performScroll, 400);
            } else {
                performScroll();
            }
        }
        
        // Update button status
        updateNavButtons();
        
        // Check end state after a short delay to ensure scroll has completed
        setTimeout(function() {
            checkScrollEndState();
        }, 200);
    }
    
    // Forward navigation / Back to start
    navNext.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const activeItem = document.querySelector('.widget-item.active');
        if (!activeItem) return;
        
        const activeItemNumber = parseInt(activeItem.getAttribute('data-item'));
        const widgetItems = document.querySelectorAll('.widget-item');
        const isLastItem = activeItemNumber === widgetItems.length;
        
        // If at the last flag, go back to first item
        if (isLastItem) {
            const firstItem = widgetItems[0];
            if (firstItem) {
                activateItem(firstItem);
            }
        } else {
            // Switch to next item
            if (activeItemNumber < widgetItems.length) {
                const nextItem = Array.from(widgetItems).find(function(item) {
                    return parseInt(item.getAttribute('data-item')) === activeItemNumber + 1;
                });
                
                if (nextItem) {
                    activateItem(nextItem);
                }
            }
        }
    });
    
    // Backward navigation
    navPrev.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const activeItem = document.querySelector('.widget-item.active');
        if (!activeItem) return;
        
        const activeItemNumber = parseInt(activeItem.getAttribute('data-item'));
        const widgetItems = document.querySelectorAll('.widget-item');
        
        // Switch to previous item
        if (activeItemNumber > 1) {
            const prevItem = Array.from(widgetItems).find(function(item) {
                return parseInt(item.getAttribute('data-item')) === activeItemNumber - 1;
            });
            
            if (prevItem) {
                activateItem(prevItem);
            }
        }
    });
    
    // Function to update visible paths
    function updateVisiblePaths(activeItemNumber) {
        const paths = document.querySelectorAll('.widget-path');
        paths.forEach(function(path) {
            const pathItemNumber = parseInt(path.getAttribute('data-item'));
            const isVisible = path.classList.contains('visible');
            
            if (pathItemNumber < activeItemNumber) {
                // Only animate if path is not yet visible
                if (!isVisible) {
                    path.classList.add('visible');
                }
            } else {
                // Hide path if it comes after the active item
                path.classList.remove('visible');
            }
        });
    }
    
    // Function to check scroll position and update arrow color
    function updateArrowColorBasedOnBackground() {
        if (!navNext || !scrollableWidget) return;
        
        // Get the scroll position
        const scrollLeft = scrollableWidget.scrollLeft;
        
        console.log('Scroll position:', scrollLeft);
        
        // Get SVG element inside navNext button
        const navNextSvg = navNext.querySelector('svg');
        if (!navNextSvg) return;
        
        // Get all path elements in the SVG
        const svgPaths = navNextSvg.querySelectorAll('path');
        
        const screenWidth = window.innerWidth;
        
        // If screen width is greater than 2327px, always make arrow white
        // If screen width is between 1770px and 2326px, also always make arrow white
        if (screenWidth > 2327 || (screenWidth >= 1770 && screenWidth <= 2326)) {
            svgPaths.forEach(function(path) {
                path.setAttribute('fill', '#ffffff');
                path.setAttribute('stroke', '#ffffff');
            });
            return;
        }
        
        // Determine threshold based on device type
        const threshold = isMobile() ? 215 : 96;
        const shouldBeWhite = scrollLeft >= threshold;
        
        // Update arrow color based on scroll position
        if (shouldBeWhite) {
            svgPaths.forEach(function(path) {
                path.setAttribute('fill', '#ffffff');
                path.setAttribute('stroke', '#ffffff');
            });
        } else {
            // Use original color
            svgPaths.forEach(function(path) {
                path.setAttribute('fill', '#592B8A');
                path.setAttribute('stroke', '#592B8A');
            });
        }
    }
    
    // Replace marker images with SVG and then initialize marker functionality
    replaceMarkerImages().then(function() {
        // Scroll to marker on click
        const widgetItems = document.querySelectorAll('.widget-item');
        
        // Activate first widget item on load (without scrolling)
        if (widgetItems.length > 0) {
            activateItem(widgetItems[0], true);
        }
        
        widgetItems.forEach(function(widgetItem) {
            widgetItem.addEventListener('click', function() {
                activateItem(widgetItem);
            });
        });
        
        // Check initial button status (after loading)
        updateNavButtons();
        
        // Initial check for end state
        setTimeout(function() {
            checkScrollEndState();
        }, 300);
        
        // Add scroll listener to check background visibility and update arrow color
        let scrollTimeout;
        scrollableWidget.addEventListener('scroll', function() {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function() {
                updateArrowColorBasedOnBackground();
                checkScrollEndState(); // Check if scrolled to end
            }, 10);
        });
        
        // Add resize listener to update arrow color when screen size changes
        let resizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                updateArrowColorBasedOnBackground();
            }, 100);
        });
        
        // Initial check
        updateArrowColorBasedOnBackground();
    });
});

